<section>
    <div class="anim-player">
        <ng-lottie ngClass="lottie-player" id="NetworkAnimation" [options]="options" (animationCreated)="animationCreated($event)" (loopComplete)="loopComplete()"></ng-lottie>
    </div>
</section>
